import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentPage: 'home', // Название страницы
    currentPageId: 0,    // Идентификатор страницы
    history: [],         // Стек истории навигации [{id, name}]
};

const pageSlice = createSlice({
    name: 'page',
    initialState,
    reducers: {
        setPage: (state, action) => {
            // Сохраняем текущую страницу в историю перед переходом
            state.history.push({
                id: state.currentPageId,
                name: state.currentPage,
            });
            // Ожидаем объект с полями `id` и `name`
            state.currentPage = action.payload.name;
            state.currentPageId = action.payload.id;
        },
        goBack: (state) => {
            const prev = state.history.pop();
            if (prev) {
                state.currentPage = prev.name;
                state.currentPageId = prev.id;
            } else {
                // Если истории нет — на главную
                state.currentPage = 'home';
                state.currentPageId = 0;
            }
        },
    },
});

export const { setPage, goBack } = pageSlice.actions;

export default pageSlice.reducer;
